import Grid from '@material-ui/core/Grid'
import DatePicker from 'Components/DatePicker'
import Search from 'Components/Search'
import Select from 'Components/Select'
import Data from 'EurestoClass/Data'
import User from 'EurestoClass/User'
import DataComponent from 'EurestoComponents/DataComponents/index'
import InputClient from 'EurestoComponents/InputClient'
import Constants from 'EurestoFonction/Constants'
import Utils from 'EurestoFonction/Utils'
import React from 'react'




const project = require('EurestoConfig/project.config')

class SearchDocument extends React.Component {

    render() {
        return <Search limit={20} all raz={true} defaultSearch={{
            ...(this.props.defaultSearch || {})
        }} path={'gestion'} requete={'document'}
            search={this.props.search || 'document_' + (this.props.name || '') + User.Entite.get().id}>
            <SearchClient />
        </Search>
    }

}

class SearchClient extends React.Component {

    constructor(props) {
        super(props)

        this.state = {
            search: props.search,
            key: Utils.getRandomNumber(),
        }
    }

    searchDocument = async (data, name) => {
        const search = this.state.search

        if (name === 'sclasseur_id') {
            if (data) {
                search.classeur_id = data
            } else {
                const classeurInfo = Data.get(Constants.module.SDD, Constants.donnee.classeur, {
                    id: search.classeur_id
                })
                if (classeurInfo && classeurInfo.classeur_id !== null) {
                    search.classeur_id = classeurInfo.classeur_id
                }
            }
        } else {
            search[name] = data
        }

        this.setState({
            search: search,
        }, () => this.props.searching && this.props.searching(search))
    }

    render() {
        return (
            <Grid key={this.state.key} container spacing={0} style={{ margin: 0, padding: 5 }} justify={'flex-start'}
                alignItems={'stretch'}
                alignContent={'flex-start'}
                direction={'column'}>
                <Select
                    title={EurestoI18n.t('commun:Type')}
                    name="type"
                    options={Object.keys(Constants.typeDocumentStock).map(key => ({
                        label: key,
                        value: Constants.typeDocumentStock[key]
                    }))}
                    value={this.state.search.type}
                    onChange={this.searchDocument} />
                <DataComponent
                    title={EurestoI18n.t('Mouvement')}
                    onChange={this.searchDocument}
                    type={Constants.typeSaisie.ComboMulti}
                    columnOptions={'abrege'}
                    data={this.state.search.mouvement_id}
                    name="mouvement_id"
                    object={Constants.donnee.type_mouvement}
                    module={Constants.module.GESTION} />
                <DataComponent
                    title={EurestoI18n.t('Lieu')}
                    onChange={this.searchDocument}
                    type={Constants.typeSaisie.ComboMulti}
                    columnOptions={'abrege'}
                    data={this.state.search.lieu_id}
                    name="lieu_id"
                    object={Constants.donnee.lieu}
                    module={Constants.module.GESTION} />

                <InputClient name={"fournisseur_id"} search={{ disabled: { qualite_id: true } }} defaultSearch={{ qualite_id: [4] }} contact_id={this.state.search.fournisseur_id} onChange={this.searchDocument} />
                <DatePicker value={this.state.search['|date_modification']}
                    range
                    disableFuture
                    title={EurestoI18n.t('commun:Date modification')}
                    onChange={this.searchDocument}
                    name={'|date_modification'} />
                <Select title={EurestoI18n.t('crm:Origine')} name="?origine"
                    autoComplete={false}
                    onChange={this.searchDocument}
                    value={this.state.search['?origine']}
                    options={[{
                        value: 'euresto',
                        label: 'Euresto'
                    }, {
                        value: 'mobile',
                        label: 'Mobile'
                    }, {
                        value: 'web',
                        label: 'Web'
                    }]} />
                <Select title={EurestoI18n.t('crm:Niveau')} name="?niveau"
                    autoComplete={false}
                    onChange={this.searchDocument}
                    value={this.state.search['?niveau']}
                    options={[{
                        value: -1,
                        label: 'À compléter'
                    }, {
                        value: 0,
                        label: 'Bloqué'
                    }, {
                        value: 1,
                        label: 'À valider'
                    }, {
                        value: 2,
                        label: 'Validé'
                    },]} />
            </Grid>
        )
    }

}

export default SearchDocument



// WEBPACK FOOTER //
// ./app/App/Module/Stock/Component/Search/index.js